module.exports = __webpack_public_path__ + "img/20190318_103536 (1).bcb17357.jpg";